import React, {Component} from 'react';
import { CardMedia, Dialog} from '@material-ui/core';

interface Props {
    open:boolean;
    media:any;
    action: () => void;
}


class ImageModal extends Component <Props>{    
    public render(){
        const {open, action, media} = this.props;        
        return(
            <Dialog disableScrollLock open={open} onClose={action} aria-labelledby="responsive-dialog-title">
              <CardMedia component="img" alt="post image"  image={media} title="Honor Wall Image"/>
            </Dialog>
        );
    }
}

export default ImageModal;